import { createAction, props } from '@ngrx/store';

export const integrateUpdate = createAction('[Integrate] update', props<{payload: any}>());
